import type { TFunction } from 'i18next';

// Booking form configuration factory function
export const getBookingConfig = (t: TFunction) => ({
    title: t('booking.title'),
    phoneNumber: '60182331065', // Your business WhatsApp number
    fields: {
        name: {
            label: t('booking.nameLabel'),
            placeholder: t('booking.namePlaceholder'),
            required: true
        },
        dateTime: {
            label: t('booking.dateTimeLabel'),
            placeholder: t('booking.dateTimePlaceholder'),
            required: true
        },
        address: {
            label: t('booking.addressLabel'),
            placeholder: t('booking.addressPlaceholder'),
            required: true
        },
        services: {
            label: t('booking.servicesLabel'),
            required: true
        }
    },
    submitButton: {
        text: t('booking.submitButton'),
        className: 'bg-blue-800 text-white px-6 py-2 rounded-md text-[14px] hover:opacity-90'
    },
    whatsappMessage: {
        format: {
            name: 'Nama: {value}',
            dateTime: 'Tarikh dan Masa: {value}',
            address: 'Alamat Tempahan untuk Servis: {value}',
            services: {
                header: 'Pilihan Servis:',
                itemPrefix: '- '
            }
        }
    }
} as const);

// Legacy export for backward compatibility (for components not yet migrated)
export const bookingConfig = {
    title: 'Tempah Servis',
    phoneNumber: '60182331065',
    fields: {
        name: {
            label: 'Nama',
            placeholder: 'Isikan Nama',
            required: true
        },
        dateTime: {
            label: 'Tarikh dan Masa',
            placeholder: 'Tarikh dan Masa',
            required: true
        },
        address: {
            label: 'Alamat Tempat untuk Servis',
            placeholder: 'Isikan Alamat',
            required: true
        },
        services: {
            label: 'Pilihan Servis',
            required: true
        }
    },
    submitButton: {
        text: 'Hantar',
        className: 'bg-blue-800 text-white px-6 py-2 rounded-md text-[14px] hover:opacity-90'
    },
    whatsappMessage: {
        format: {
            name: 'Nama: {value}',
            dateTime: 'Tarikh dan Masa: {value}',
            address: 'Alamat Tempahan untuk Servis: {value}',
            services: {
                header: 'Pilihan Servis:',
                itemPrefix: '- '
            }
        }
    }
} as const;

export type BookingConfigType = ReturnType<typeof getBookingConfig>;